module.exports = __webpack_public_path__ + "media/images/noticias/viejas/place_mujer-99a8e09cfde7a66381eccd423255a86d.jpg";